Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pin = void 0;
var _react = _interopRequireDefault(require("react"));
var _generalObserver = require("../general-observer");
var _utils = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Pin = function Pin(_ref) {
  var pinId = _ref.pinId,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handlePinterestBuild)();
    }
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "pinterest-pin pinterest-pin-mdx-embed",
    "data-testid": "pin",
    "data-pin-do": "embedPin",
    "data-pin-width": size,
    href: "https://www.pinterest.com/pin/".concat(pinId)
  }));
};
exports.Pin = Pin;